import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { CtaRow, GhostCta, PrimaryCta, StoreBadges, useLanding } from '@/components/Landing/LandingKit';
import { BILLING, CLOSING_TRUST } from '@/constants/pricingContent';
import { PricingSection, PricingTitle } from './PricingKit';

function PricingClosing() {
  const { c, band, isXS, isCompact } = useLanding();
  return (
    <PricingSection label="Start using Gab AI" background={band.bg}>
      <View style={{ flexDirection: isCompact ? 'column' : 'row', alignItems: isCompact ? 'stretch' : 'center', gap: 28 }}>
        <View style={{ flex: isCompact ? undefined : 1 }}>
          <PricingTitle>Start with an idea.</PricingTitle>
          <Text style={{ color: c.inkSoft, fontSize: 16, lineHeight: 27, marginTop: 14, maxWidth: 520 }}>
            Try Gab AI free. Get the Work Agent with Plus from ${BILLING.annualPerMonth} a month, billed annually.
          </Text>
        </View>
        <View style={{ gap: 12 }}>
          <CtaRow>
            <PrimaryCta restrained label="Start free" full={isXS} />
            <GhostCta label="See what it can do" href="/about" />
          </CtaRow>
          <Text style={{ color: c.muted, fontSize: 12, lineHeight: 20 }}>{CLOSING_TRUST.join(' · ')}</Text>
        </View>
      </View>
      <View style={{ marginTop: 36, paddingTop: 26, borderTopWidth: 1, borderTopColor: c.rule, flexDirection: isCompact ? 'column' : 'row', alignItems: isCompact ? 'flex-start' : 'center', justifyContent: 'space-between', gap: 20 }}>
        <Text style={{ color: c.muted, fontSize: 13, lineHeight: 21 }}>On the web, iPhone, iPad, Mac, and Android.</Text>
        <StoreBadges scale={0.85} />
      </View>
    </PricingSection>
  );
}

export default React.memo(PricingClosing);
